var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartHealthDiary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4886 2.45257C20.623 -0.413103 16.0721 -0.590907 13 1.92052C9.92786 -0.590848 5.37698 -0.413103 2.51136 2.45257C1.03409 3.92984 0.206581 5.90909 0.206581 8.00741C0.206581 10.1056 1.03409 12.085 2.51136 13.5623L13 24.0497L23.4886 13.5611C24.9659 12.0838 25.7934 10.1045 25.7934 8.00623C25.7934 5.90918 24.9959 3.9588 23.4886 2.45257ZM5.11166 13.7974H8.80484L10.0455 10.0455L12.8823 18.377L15.8658 12.1136L16.4568 13.7975H20.8886L13.0002 21.6858L5.11166 13.7974ZM17.6383 12.1136H22.5432C24.7291 9.7201 24.6403 5.96795 22.3066 3.63433C19.9129 1.24067 15.9844 1.24067 13.5907 3.63433L12.9998 4.22524L12.4089 3.63433C10.0151 1.24067 6.08665 1.24067 3.693 3.63433C1.3582 5.96783 1.29935 9.69109 3.4564 12.1136H7.59277L10.0153 4.75735L13.1477 13.9164L16.1022 7.7119L17.6383 12.1136Z",
    fill: "#0F5FBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealthDiary);
export default __webpack_public_path__ + "static/media/HeartHealthDiary.d9bd985ec89344db731f285646d198d7.svg";
export { ForwardRef as ReactComponent };